import {
  permissionDenied,
  useCheckPermissions,
} from '@user/store/authorization/permissions'
import { branchUnmapped } from '@user/store/draftLeads/constants'
import type { DraftLead } from '@user/store/draftLeads/typings'
import { useAutoReviewPendingLeadsEnabled } from '@user/store/tenantFeatures/hooks/useAutoReviewPendingLeadsEnabled'

import { isAutoReviewBlocked } from '../utils/isAutoReviewBlocked'

/**
 * Computes, once per card, whether the pending lead is blocked from auto-review and whether
 * the "Update Required Fields" action is currently disabled (and why).
 */
export function useIsAutoReviewBlocked(
  lead: Pick<
    DraftLead,
    'isMissingAutoReviewFields' | 'type' | 'isBranchMapped' | 'branchId'
  >,
) {
  const flagEnabled = useAutoReviewPendingLeadsEnabled()
  const [canAddLeads] = useCheckPermissions('leads_add')

  const blocked = isAutoReviewBlocked({ flagEnabled, lead })
  const branchUnmappedForLead = !lead.isBranchMapped && lead.branchId !== null
  const actionDisabled = !canAddLeads || branchUnmappedForLead

  let disabledReason: string | undefined
  if (!canAddLeads) disabledReason = permissionDenied
  else if (branchUnmappedForLead) disabledReason = branchUnmapped

  return { blocked, actionDisabled, disabledReason }
}
